/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{9BFA902A-2E1F-402E-BE36-A1BE97F2A68D}",
  "sitecoreApiHost": "",
  "jssAppName": "altudo",
  "defaultLanguage": "en"
};